import { AssetMaintenanceService } from '../model/asset-maintenance.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { AssetMaintenance } from 'assets-model';
import { Observable } from 'rxjs';


export class AssetMaintenanceDataSource extends CrudDataSource<AssetMaintenance> {

  constructor(private service: AssetMaintenanceService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<AssetMaintenance>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


